'use client';

import { useCallback } from 'react';
import Button from '@/components/shared/button/Button';

type Props = {
  listingUrl: string;
  buttonText: string;
};

export default function MicrositeButton({ listingUrl, buttonText }: Props): JSX.Element {
  const onClick = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      window.open(listingUrl);
    },
    [listingUrl]
  );
  return (
    <Button
      testID="market-comp-learn-more-button"
      text={buttonText}
      aria-label={buttonText}
      onClick={onClick}
      isBlock
    />
  );
}
